import React from 'react';
import { FadeIn } from './FadeIn';
export function UpsellSection() {
  const comparisonData = [{
    situation: 'Él vuelve pero está frío y distante',
    without: 'No sabés cómo manejarlo y lo presionás',
    with: 'Ritual de Calma y Sostenimiento. Ya está.'
  }, {
    situation: 'Hay una ex o tercera persona rondando',
    without: 'Entrás en pánico y actuás desde miedo',
    with: 'Ritual de Espejo de Protección. Activo.'
  }, {
    situation: 'Volvieron pero discuten igual que antes',
    without: 'Mismo patrón, misma ruptura en 15 días',
    with: 'La Dieta del Drama. Comunicación nueva.'
  }, {
    situation: 'Tu familia o suegra interfiere',
    without: 'Explosión de conflictos sin solución',
    with: 'Sahumerio de Blindaje. Energía limpia.'
  }, {
    situation: 'Repetís el mismo patrón en cada relación',
    without: 'Seguís atrayendo lo que no querés',
    with: 'Sanación de Linaje. ADN espiritual nuevo.'
  }, {
    situation: 'Él vuelve pero sentís que no te valora',
    without: 'Bajás tus límites por miedo a perderlo',
    with: 'Protocolo de Soberanía. Valor blindado.'
  }];
  const features = ['Ritual del Hilo de Oro (vincular almas sin manipulación)', 'Sellado con Cera Dorada (frasco permanente de convivencia)', 'Sahumerio de Sanación del Hogar (borrar el "fantasma" de las peleas)', 'Aceite de Unión Premium (Mirra + Sándalo + partículas de oro)', 'Rituales de Cama Sagrada (paz adictiva a tu lado)', 'Sanación de Linaje: El Ritual de las 7 Generaciones', 'Ritual de Corte de Lazos con Ex-Parejas', 'Blindaje contra Terceros (ético y limpio)', 'El Espejo de Protección (mal de ojo de vuelta)', 'La Dieta del Drama: 21 días sin queja ni reclamo', 'Scripts de Primera Conversación Seria (límites sin pelea)', 'El Arte de la Indisponibilidad Soberana', 'Plan de Mantenimiento 12 Meses (1 ritual por luna llena)'];
  return <section className="py-16 px-4 bg-miel-dark relative border-t border-miel-crimson/20" data-id="element-354">
      <div className="max-w-5xl mx-auto" data-id="element-355">
        <FadeIn data-id="element-356">
          <div className="text-center mb-10" data-id="element-357">
            <div className="text-4xl mb-4" data-id="element-358">🕊️</div>
            <h2 className="font-playfair text-3xl md:text-4xl text-miel-gold mb-4" data-id="element-359">
              ¿QUÉ AGREGA EL SELLO DE ORO AL PROTOCOLO?
            </h2>
          </div>
        </FadeIn>

        {/* Comparison Table */}
        <FadeIn delay={0.2} data-id="element-360">
          <div className="overflow-x-auto mb-16 pb-4" data-id="element-361">
            <div className="min-w-[800px] w-full bg-miel-darker rounded-xl border border-miel-gold/20 overflow-hidden" data-id="element-362">
              <div className="grid grid-cols-3 bg-miel-dark border-b border-miel-gold/20" data-id="element-363">
                <div className="p-4 font-playfair text-miel-cream font-bold text-lg" data-id="element-364">
                  Situación real
                </div>
                <div className="p-4 font-playfair text-miel-cream/60 font-bold text-lg flex items-center gap-2" data-id="element-365">
                  <span className="text-miel-red" data-id="element-366">❌</span> Solo con El
                  Protocolo
                </div>
                <div className="p-4 font-playfair text-miel-gold font-bold text-lg flex items-center gap-2 bg-miel-gold/5" data-id="element-367">
                  <span className="text-green-400" data-id="element-368">✅</span> Con Sello de Oro
                </div>
              </div>

              {comparisonData.map((row, i) => <div key={i} className="grid grid-cols-3 border-b border-miel-crimson/10 last:border-0 hover:bg-miel-dark/30 transition-colors" data-id="element-369">
                  <div className="p-4 text-sm text-miel-cream/90 font-medium" data-id="element-370">
                    {row.situation}
                  </div>
                  <div className="p-4 text-sm text-miel-cream/50" data-id="element-371">
                    {row.without}
                  </div>
                  <div className="p-4 text-sm text-miel-goldLight bg-miel-gold/5 font-medium" data-id="element-372">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Features List */}
        <FadeIn delay={0.4} data-id="element-373">
          <div className="bg-gradient-to-br from-miel-darker to-miel-dark border border-miel-gold/30 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-374">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-miel-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-375" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-miel-crimson/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-376" />

            <h3 className="font-playfair text-2xl md:text-3xl text-miel-gold mb-8 text-center relative z-10" data-id="element-377">
              ✅ EL SELLO DE ORO INCLUYE:
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 relative z-10" data-id="element-378">
              {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-379">
                  <span className="text-miel-gold mt-1 shrink-0" data-id="element-380">✨</span>
                  <span className="text-miel-cream/90 text-sm md:text-base" data-id="element-381">
                    {feature}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}